import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from './ui/button';

const MobileMenu = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      <div className="fixed inset-0 bg-black/80" onClick={onClose} />
      <div className="fixed right-0 top-0 h-full w-[280px] bg-black border-l border-gray-800 shadow-xl">
        <div className="flex items-center justify-between p-6 border-b border-gray-800">
          <h2 className="text-white font-bold text-xl">Menü</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X size={24} />
          </button>
        </div>

        <nav className="p-6 space-y-4">
          <Link
            to="/vizyondaki-filmler"
            onClick={onClose}
            className="block text-gray-300 hover:text-white transition-colors py-2"
          >
            Vizyondakiler
          </Link>
          <Link
            to="/yakinda"
            onClick={onClose}
            className="block text-gray-300 hover:text-white transition-colors py-2"
          >
            Yakında
          </Link>
          <Link
            to="/kampanyalar"
            onClick={onClose}
            className="block text-gray-300 hover:text-white transition-colors py-2"
          >
            Kampanyalar
          </Link>
          <Link
            to="/haberler"
            onClick={onClose}
            className="block text-gray-300 hover:text-white transition-colors py-2"
          >
            Haberler
          </Link>
          <Link
            to="/salonlarimiz"
            onClick={onClose}
            className="block text-gray-300 hover:text-white transition-colors py-2"
          >
            Salonlarımız
          </Link>
          <Link
            to="/iletisim"
            onClick={onClose}
            className="block text-gray-300 hover:text-white transition-colors py-2"
          >
            İletişim
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;
